import "./index.css";
import "./i18n";
import Player from "./components/Player";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";
import { PlayerProvider } from "./lib/PlayerContext";
import { AnalyticsProvider, useAnalytics } from "./lib/AnalyticsContext";

// UMDビルド用にReactとReactDOMを直接エクスポート
export const R = React;
export const RD = ReactDOM;
export const RDC = ReactDOMClient;

// コンポーネントのエクスポート
export { Player, PlayerProvider, AnalyticsProvider, useAnalytics };
